import React from 'react'
import { Redirect, useLocation } from 'react-router-dom'

const ProtectRoute = ({
  children,
  callback,
  redirectTo,
}: {
  children: JSX.Element
  callback: (token: string | null) => boolean
  redirectTo: string
}): JSX.Element => {
  const location = useLocation()
  const token = localStorage.getItem('token')

  if (['/login', '/vendorLogin'].includes(location.pathname)) {
    return children
  }

  return callback(token) ? children : <Redirect to={redirectTo} />
}

export default ProtectRoute
